export class State {

	constructor(id: number) {
		this.id = id;
	}

	id: number;
	name: string;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/State.ts